var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5781C14.6574 17.5781 16.4062 15.8292 16.4062 13.6719C16.4062 11.5145 14.6574 9.76562 12.5 9.76562C10.3426 9.76562 8.59375 11.5145 8.59375 13.6719C8.59375 15.8292 10.3426 17.5781 12.5 17.5781Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 11.3281C20.0505 11.3266 20.9482 11.5377 21.7621 11.9447C22.5759 12.3516 23.2834 12.943 23.8281 13.6719",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17188 13.6719C1.7166 12.943 2.4241 12.3516 3.23795 11.9447C4.05179 11.5377 4.94947 11.3266 5.85938 11.3281",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 21.0937C7.38948 20.0401 8.18953 19.1521 9.18403 18.531C10.1785 17.9099 11.3275 17.5806 12.5 17.5806C13.6725 17.5806 14.8215 17.9099 15.816 18.531C16.8105 19.1521 17.6105 20.0401 18.125 21.0937",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85937 11.3281C5.26625 11.3287 4.6852 11.1605 4.18413 10.8432C3.68305 10.5258 3.28264 10.0724 3.02967 9.53592C2.77671 8.99945 2.68164 8.40206 2.75558 7.81357C2.82952 7.22507 3.06941 6.66977 3.44722 6.21254C3.82503 5.75532 4.32516 5.41506 4.88917 5.23151C5.45318 5.04797 6.05778 5.02873 6.63232 5.17604C7.20686 5.32334 7.72761 5.63111 8.13373 6.06338C8.53985 6.49566 8.81457 7.03458 8.92578 7.61719",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0742 7.61719C16.1854 7.03458 16.4601 6.49566 16.8663 6.06338C17.2724 5.63111 17.7931 5.32334 18.3677 5.17604C18.9422 5.02873 19.5468 5.04797 20.1108 5.23151C20.6748 5.41506 21.175 5.75532 21.5528 6.21254C21.9306 6.66977 22.1705 7.22507 22.2444 7.81357C22.3184 8.40206 22.2233 8.99945 21.9703 9.53592C21.7174 10.0724 21.3169 10.5258 20.8159 10.8432C20.3148 11.1605 19.7337 11.3287 19.1406 11.3281",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersThree);
export default __webpack_public_path__ + "static/media/users-three.d91a1364.svg";
export { ForwardRef as ReactComponent };